jQuery(document).ready(function($){
  $(".btn-video").modalVideo({channel:'vimeo'});
//   if($('.number-counter').length > 0) {
//     var counterDelay = $('#section-header').attr('data-counter-delay');
//     var counterTime = $('#section-header').attr('data-counter-time');
//     $('.number-counter').counterUp({
//       delay: counterDelay,
//       time: counterTime
//     });
//     $('.number-counter').addClass('animated fadeInDownBig');
//   }
  
  
  
  // Header scroll hide/show is handled in theme-custom.js
  $('.search_block_item .text-md.capitalize.cursor-pointert').click(function(e){
    	e.preventDefault();
      	var ele = $(this).closest('#Search').find('.Search__Input');
        ele.val($(this).text());
      //$(this).closest('#Search').find('.Search__Form').submit();
  });
  if($('#curated-reviews-images-desktop .image-wrapper').length <= 20)
    $('.load-more').hide();
  if($('#shopify-section-product-curated-reviews').length > 0) {
    var review_group = 1;
    $('#shopify-section-product-curated-reviews .group:nth-of-type('+review_group+')').show();
    $('#shopify-section-product-curated-reviews').on('click', '.load-more:not(.show-less)', function () {
      review_group++;
      //$('#shopify-section-product-curated-reviews .group').hide();
      $('#shopify-section-product-curated-reviews .group:nth-of-type('+review_group+')').fadeIn();
      //$([document.documentElement, document.body]).animate({
      //  scrollTop: $("#shopify-section-product-curated-reviews").offset().top
      //}, 500);
      if (review_group == 3) {
        $(this).html('SHOW LESS').addClass('show-less');
      }
      return false;
    })
    $('#shopify-section-product-curated-reviews').on('click', '.show-less', function () {
      $('#shopify-section-product-curated-reviews .group:nth-of-type('+review_group+')').fadeOut();
      review_group--;
      console.log(review_group)
      console.log($('#shopify-section-product-curated-reviews .group:nth-of-type('+review_group+')').offset().top)
      $([document.documentElement, document.body]).animate({
       scrollTop: $('#shopify-section-product-curated-reviews .group:nth-of-type('+review_group+')').offset().top
      }, 300);
      if (review_group == 1) {
        $(this).html('SHOW MORE').removeClass('show-less');
      }
      return false;
    })
  }  
  
  if($('.ratting-list').length > 0) {
    $('.ratting-list').owlCarousel({
      loop:false,
      margin:0,
      nav:true,
      responsiveClass:true,
      items:3,
      mouseDrag:true,
      touchDrag:true,
      pullDrag:false,
      freeDrag:false,
      responsive:{
        0:{
          items:1,
          loop:true,
          mouseDrag:true
        },
        480:{
          items:2,
          loop:true,
          mouseDrag:true
        },
        641:{
          items:3,
          touchDrag:false,
          mouseDrag:false
        }
      }
    })
  }
  if($('.app-store').length > 0) {
    $('.app-store').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      responsiveClass:true,
      items:3,
      mouseDrag:true,
      touchDrag:true,
      pullDrag:false,
      freeDrag:false,
      responsive:{
        0:{
          items:3,
          loop:true,
          mouseDrag:true
        },
        400:{
          items:3,
          loop:true,
          mouseDrag:true
        },
        641:{
          items:3,
          touchDrag:false,
          mouseDrag:false,
          loop:false
        }
      }
    })
  }
  AOS.init();
  
//   var waitForEl = function(selector, callback) {
//     if (jQuery(selector).length) {
//       callback();
//     } else {
//       setTimeout(function() {
//         waitForEl(selector, callback);
//       }, 100);
//     }
//   };

//   var selector = $('.bottom-line-items');
//   waitForEl(selector, function() {
//     console.log('11111');
//     $('.avg-score').hide();
//   });
})